import { css } from '@bts-web/utils-style-engine';

export const digitInputWrapperStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 'extra_small_2',
});

export const titleStyles = css({
  fontSize: 'headline.large_semi_bold',
  fontWeight: 'headline.large_semi_bold',
  letterSpacing: 'headline.large_semi_bold',
  lineHeight: 'headline.large_semi_bold',
  color: 'neutrals.text_primary',
});

export const subtitleStyles = css({
  fontSize: 'body.medium',
  fontWeight: 'body.medium',
  letterSpacing: 'body.medium',
  lineHeight: 'body.medium',
  color: 'neutrals.text_secondary',
});

export const errorStyles = css({
  fontSize: 'body.medium',
  fontWeight: 'body.medium',
  letterSpacing: 'body.medium',
  lineHeight: 'body.medium',
  color: 'negative.stroke_primary',
});
